import React from "react";
import { noop } from "@common/helpers/function";
import { FilterActionsFooter } from "@design-system/Filter/FilterActionsFooter/FilterActionsFooter";
import {
    FilterMultiselect,
    FilterMultiselectOption,
    FilterMultiselectValue,
} from "@components/pageHeader/filters/FilterMultiselect/FilterMultiselect";
import styles from "../TransactionStatusFilter/TransactionStatusFilter.module.scss";

interface Props<TValue extends string> {
    options: FilterMultiselectOption[];
    selected: string[] | undefined;
    isOptionValue: (value: FilterMultiselectValue) => value is TValue;
    onChange: (values: TValue[] | undefined) => void;
    name: string;
    searchable?: boolean;
}

export const OrgTaskTemplateOptionsFilter = <TValue extends string>({
    options,
    selected = [],
    isOptionValue,
    onChange,
    name,
    searchable,
}: Props<TValue>) => (
    <div className={styles.filter}>
        <FilterMultiselect
            maxListHeight={320}
            inDropdown={false}
            searchable={searchable}
            options={options}
            value={selected}
            onChange={(values) => {
                const optionValues = values.filter(isOptionValue);
                onChange(optionValues.length ? optionValues : undefined);
            }}
            name={name}
            onBlur={noop}
        />
        {selected.length > 0 && (
            <FilterActionsFooter
                deselectFunction={() => onChange(undefined)}
                selectedCount={selected.length}
            />
        )}
    </div>
);
